import React from 'react'
import { styled } from '@mui/material'
import { useAssessmentItemScoring } from '@app/helpers'
import { ItemFeedback } from './ItemFeedback'

const StyledFeedback = styled(ItemFeedback)(({ theme }) => ({
  marginTop: theme.spacing(4),
}))

type Props = {
  itemId: string
  generalFeedback?: React.ReactNode
}

export const QuestionFeedback: React.FC<Props> = ({ itemId, generalFeedback }) => {
  const itemScoring = useAssessmentItemScoring(itemId)

  if (!itemScoring) {
    return null
  }

  return (
    <>
      <StyledFeedback
        correct={itemScoring.possible === itemScoring.raw}
        raw={itemScoring.raw}
        possible={itemScoring.possible}
        generalFeedback={generalFeedback}
      />
    </>
  )
}
